import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shortcut-child-body" }
const _hoisted_2 = { class: "content-body" }
const _hoisted_3 = { class: "setting-child-body" }
const _hoisted_4 = { class: "setting-item-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "setting-child-body" }
const _hoisted_7 = { class: "setting-item-container gimbal-container" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "setting-child-body" }
const _hoisted_10 = { class: "setting-item-container gimbal-container" }
const _hoisted_11 = ["onClick"]

import { ref, reactive, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import { getUserKeyboardKeybinding, saveUserKeyboardKeybinding } from '@/service'
import {useStore} from 'vuex'
import { $enum } from '@/global'
import keyboardConverter from '@/utils/keyboardConverter'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const loading = ref(false)
const saveLoading = ref(false)
let messageDuration = 1200
const { proxy } = getCurrentInstance()!
const keyboardConvert = new keyboardConverter()

// 当前快捷键配置
const shortcutConfig = ref({
  flight: [
    {label:"上升", key:"",code:"", paramName:"moveUp"},
    {label:"左转", key:"",code:"", paramName:"turnLeft"},
    {label:"前进", key:"",code:"", paramName:"moveForward"},
    {label:"向左", key:"",code:"", paramName:"moveLeft"},
    {label:"下降", key:"",code:"", paramName:"moveDown"},
    {label:"右转", key:"",code:"", paramName:"turnRight"},
    {label:"后退", key:"",code:"", paramName:"moveBackward"},
    {label:"向右", key:"",code:"", paramName:"moveRight"}
  ],
  gimbal: [
    {label:"变焦+", key:"",code:"", paramName:"enlarge"},
    {label:"云台向上", key:"", code:"",paramName:"ytUp"},
    {label:"拍照", key:"",code:"", paramName:"shoot"},
    {label:"变焦-", key:"",code:"", paramName:"reduce"},
    {label:"云台向下", key:"", code:"",paramName:"ytDown"},    
    {label:"查看图片", key:"",code:"", paramName:"openAlbum"},
  ],
  other: [
    {label:"重置", key:"",code:"",paramName:"reset"},
    {label:"视角", key:"",code:"",paramName:"switchView"},
    {label:"返航", key:"",code:"",paramName:"homing"},
    {label:"引导", key:"",code:"",paramName:"switchGuid"},
    {label:"退出", key:"",code:"",paramName:"quit"},
  ]
})

// 当前正在编辑的项目
const editingItem = ref(null)

// 开始编辑快捷键
function startEdit(category, index) {
  editingItem.value = `${category}-${index}`
}

// 处理键盘按键事件
function handleKeyDown(event) {
  if (!editingItem.value) return
  event.preventDefault()
  const keyCode = event.keyCode
  const keyValue = keyboardConvert.getKeyInfoByKeyCode(keyCode)[2]
  
  // 检查是否为禁用键
  if (keyboardConvert.isDisabledKeyCode(keyCode)) {
    return
  }
  
  // 获取当前编辑的分类和索引
  const [category, indexStr] = editingItem.value.split('-')
  const index = parseInt(indexStr)
  
  // 更新快捷键配置
  shortcutConfig.value[category][index].key = keyValue
  shortcutConfig.value[category][index].code = keyCode
  // // 检查冲突并处理
  checkAndResolveConflicts(category, index, keyValue)
  
}

// 检查并解决快捷键冲突
function checkAndResolveConflicts(currentCategory, currentIndex, newKey) {
  // 遍历所有快捷键配置
  for (const category in shortcutConfig.value) {
    for (let i = 0; i < shortcutConfig.value[category].length; i++) {
      // 跳过当前正在编辑的项目
      if (category === currentCategory && i === currentIndex) continue
      
      // 如果找到相同的按键，将其设置为"--"
      // 使用严格相等比较，区分大小写 ('a' !== 'A')
      if (shortcutConfig.value[category][i].key == newKey) {
        shortcutConfig.value[category][i].key = '--'
      }
    }
  }
}

async function getData(id:string | number){
    if(id == -1){
      clearShortcuts()
      window?.playClick()
      loading.value = true
    }
    let {code,data} = await getUserKeyboardKeybinding({id:id}) as any
    if(loading.value){
        loading.value = false
    }
    if(code != $enum.EnumResult.SUCCESS){
        if(id == -1){
            proxy?.vknMessage.error({
                message:"恢复默认失败！",
                duration: messageDuration,
            })
        }
        return;
    }
    if(id == -1){
      proxy?.vknMessage.success({
        message:"恢复默认成功！",
        duration: messageDuration,
      })
    }
    editingItem.value = null
    if(data && Object.keys(data).length > 0){
      for (const category in shortcutConfig.value) {
        for (let i = 0; i < shortcutConfig.value[category].length; i++) {
          let keyName = shortcutConfig.value[category][i].paramName
          if(data[keyName] != "" && data[keyName] != null && data[keyName] != undefined){
            let code = parseInt(data[keyName])
            shortcutConfig.value[category][i].key = keyboardConvert.getKeyInfoByKeyCode(code)[2]
            shortcutConfig.value[category][i].code = code
          }
        }
      }
    }
}

// 保存设置 
async function saveSensitivity() {
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "moveUp": "",
    "moveDown": "",
    "turnLeft": "",
    "turnRight": "",
    "moveForward": "",
    "moveBackward": "",
    "moveLeft": "",
    "moveRight": "",
    "enlarge": "",
    "reduce": "",
    "ytUp": "",
    "ytDown": "",
    "shoot": "",
    "openAlbum": "",
    "reset": "",
    "switchGuid": "",
    "switchView": "",
    "quit": "",
    "homing": ""
  }
  for (const category in shortcutConfig.value) {
    for (let i = 0; i < shortcutConfig.value[category].length; i++) {
      let keyName = shortcutConfig.value[category][i].paramName
      if(shortcutConfig.value[category][i].key == "--") continue
      param[keyName] = shortcutConfig.value[category][i].code
    }
  }
  saveLoading.value = true
  let {code,data} = await saveUserKeyboardKeybinding(param) as any
  saveLoading.value = false
  if(code != $enum.EnumResult.SUCCESS){
    proxy?.vknMessage.error({
        message:"保存失败！",
        duration: messageDuration,
    })
    return;
  }
  editingItem.value = null
  store.commit('persistence/setKeyboard', {reset:param.reset,switchGuid:param.switchGuid,switchView:param.switchView,homing:param.homing,enlarge:param.enlarge,reduce:param.reduce,shoot:param.shoot})
  proxy?.vknMessage.success({
        message:"保存成功！",
        duration: messageDuration,
    })
}

// 清理快捷键
function clearShortcuts() {
  for (const category in shortcutConfig.value) {
    for (let i = 0; i < shortcutConfig.value[category].length; i++) {
      shortcutConfig.value[category][i].key = ''
      shortcutConfig.value[category][i].code = ''
    }
  }
}

// 组件挂载时添加事件监听器
onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
  getData(store.state.persistence.userInfo.userId)
})

// 组件卸载时移除事件监听器
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown)
})

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_vkm_settingChildPage = _resolveComponent("vkm-settingChildPage")!

  return (_openBlock(), _createBlock(_component_vkm_settingChildPage, {
    class: "shortcut-container",
    "restore-loading": loading.value,
    "save-loading": saveLoading.value,
    onRestore: _cache[0] || (_cache[0] = ($event: any) => (getData(-1))),
    onSave: saveSensitivity
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "title-text" }, "飞行", -1)),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortcutConfig.value.flight, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "setting-item",
                      key: index
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.label), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["setting-item-content", {editing: editingItem.value === `flight-${index}`}]),
                        onClick: ($event: any) => (startEdit('flight', index))
                      }, _toDisplayString(item.key), 11, _hoisted_5)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "title-text" }, "云台", -1)),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortcutConfig.value.gimbal, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "setting-item",
                      key: index
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.label), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["setting-item-content", {editing: editingItem.value === `gimbal-${index}`}]),
                        onClick: ($event: any) => (startEdit('gimbal', index))
                      }, _toDisplayString(item.key), 11, _hoisted_8)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "title-text" }, "其他", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortcutConfig.value.other, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "setting-item",
                      key: index
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.label), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["setting-item-content", {editing: editingItem.value === `other-${index}`}]),
                        onClick: ($event: any) => (startEdit('other', index))
                      }, _toDisplayString(item.key), 11, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["restore-loading", "save-loading"]))
}
}

})